// React Basic and Bootstrap
import React from "react"
import { graphql, Link, useStaticQuery } from "gatsby"
import { Container, Row, Col, Card, CardBody } from "reactstrap"

// icons
import { UilFile } from "@iconscout/react-unicons"
import { UilGraduationCap } from "@iconscout/react-unicons"
import { UilBookReader } from "@iconscout/react-unicons"

const Feature = () => {
  const data = useStaticQuery(graphql`
    {
      markdownRemark(frontmatter: { contentKey: { eq: "academyPage" } }) {
        frontmatter {
          features {
            feature_1 {
              Title_of_feature_1_
              description_of_feature_1
            }
            feature_2 {
              Title_of_feature_2_
              description_of_feature_2
            }
            feature_3 {
              Title_of_feature_3
              description_of_feature_3
            }
          }
        }
      }
    }
  `)

  const { feature_1, feature_2, feature_3 } =
    data.markdownRemark.frontmatter.features

  const features = [
    {
      icon: <UilFile />,
      title: feature_1.Title_of_feature_1_,
      desc: feature_1.description_of_feature_1,
    },
    {
      icon: <UilGraduationCap />,
      title: feature_2.Title_of_feature_2_,
      desc: feature_2.description_of_feature_2,
    },
    {
      icon: <UilBookReader />,
      title: feature_3.Title_of_feature_3,
      desc: feature_3.description_of_feature_3,
    },
  ]

  return (
    <>
      <section className="section">
        <Container>
          <Row>
            <Col xs={12}>
              <div className="features-absolute">
                <Row>
                  {features.map((feature, key) => (
                    <Col md={4} key={key}>
                      <Card className="border-0 text-center features feature-clean course-feature p-4 overflow-hidden shadow">
                        <div className="icons text-primary text-center mx-auto">
                          <i className="d-block rounded h3 mb-0">
                            {feature.icon}
                          </i>
                        </div>
                        <CardBody className="p-0 mt-4">
                          <h4 className="mt-3">
                            <Link
                              to={feature.link}
                              className="title h5 text-dark"
                            >
                              {" "}
                              {feature.title}
                            </Link>
                          </h4>
                          <p className="text-muted mt-2">{feature.desc} </p>
                        </CardBody>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default Feature
